import { isCometMcpSourceType } from '#pplx/frontend/apps/ask/sources/types/cometMcpSourceTypes.js';
export function resolveSourceMentionIcon({ sourceId, iconUrl, }) {
    // Comet MCP sources are not part of the REST source-icon registry. Their
    // installed-server image is the canonical mention icon when one exists.
    if (!isCometMcpSourceType(sourceId)) {
        return { type: 'source', sourceId };
    }
    return iconUrl ? { type: 'image', url: iconUrl } : undefined;
}
//# sourceMappingURL=resolveSourceMentionIcon.js.map